import { render, staticRenderFns } from "./BatchRescue.vue?vue&type=template&id=36f6e806&"
import script from "./BatchRescue.vue?vue&type=script&lang=js&"
export * from "./BatchRescue.vue?vue&type=script&lang=js&"
import style0 from "./BatchRescue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f6e806')) {
      api.createRecord('36f6e806', component.options)
    } else {
      api.reload('36f6e806', component.options)
    }
    module.hot.accept("./BatchRescue.vue?vue&type=template&id=36f6e806&", function () {
      api.rerender('36f6e806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchRescue.vue"
export default component.exports